/**
 * A mixin for initializing and updating Vue data properties via the
 * sessionStorage API. When mounted, the mixin will check to see if
 * the provided data property has a value currently stored in the session.
 * If it does, the data property is updated with that value. Similarly,
 * any time that data property changes, the session storage property value
 * is updated.
 *
 * @param {Object} options
 * @param {String[]} options.properties - Data properties to store and update in session
 * @param {String} options.suffix - Suffix to add to the session object's key
 *
 * Note: move to Vue 3's composition API when available.
 */
export default ({ properties, suffix = 'session' }) => {
  // Construct Vue's "watch" object
  const watchers = properties.reduce((watchObj, property) => {
    watchObj[property] = {
      handler (newVal) {
        // Stringify to handle arrays and objects as well
        sessionStorage.setItem(`${property}___${suffix}`, JSON.stringify(newVal))
      },
    }
    return watchObj
  }, {})

  return {
    watch: { ...watchers },
    mounted () {
      properties.forEach(property => {
        const storedPropertyValue = JSON.parse(sessionStorage.getItem(`${property}___${suffix}`))
        if (storedPropertyValue) {
          this[property] = storedPropertyValue
        }
      })
    },
  }
}
